import { memo, useState } from 'react';

import dayjs from 'dayjs';
import { isEmpty } from 'remeda';

import { DateTimePicker } from '@mui/x-date-pickers';
import { PickerValue } from '@mui/x-date-pickers/internals';

interface DateTimeFilterProps {
  label: string;
  value: string;
  onChange: (isoDate: string) => void;
}

// The picker keeps its own value: a half-typed date is invalid and must not wipe the field,
// only a complete date (or a cleared field) goes to the filter.
export const DateTimeFilter = memo<DateTimeFilterProps>(({ label, value, onChange }) => {
  const [pickerValue, setPickerValue] = useState<PickerValue>(() => (isEmpty(value) ? null : dayjs(value)));

  const handleChange = (nextValue: PickerValue) => {
    setPickerValue(nextValue);

    if (nextValue === null) {
      onChange('');
    } else if (nextValue.isValid()) {
      onChange(nextValue.toISOString());
    }
  };

  return (
    <DateTimePicker
      label={label}
      value={pickerValue}
      onChange={handleChange}
      format="DD.MM.YYYY HH:mm"
      ampm={false}
      slotProps={{ textField: { size: 'small' }, field: { clearable: true } }}
    />
  );
});

DateTimeFilter.displayName = 'DateTimeFilter';
